import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import './no-results.scss';
import { ExtensionTypes } from '../../../../store/features/system';
export const TRANSLATIONS = {
    [ExtensionTypes.installed]: {
        noResultMsgKey: 'account.marketplace.no-installed-extensions',
    },
    [ExtensionTypes.uninstalled]: {
        noResultMsgKey: 'account.marketplace.no-not-installed-extensions',
    },
};
export const NoResults = ({ show }) => {
    return (<div className={classnames('NoResults', { 'is-hidden': !show })}>
      <img src="/assets/icons/legacy/no-extensions.svg" alt="No extensions installed"/>
      <FormattedMessage id={'account.marketplace.no-not-installed-extensions'}/>
    </div>);
};
